class LanguageDropdown {
  constructor(selector) {
      this.dropdown = document.querySelector(selector);

      if(this.dropdown) {
        this.button = this.dropdown.querySelector('.language-selector__button'); 
        this.menu = this.dropdown.querySelector('.language-selector__menu');
      }

      this.init();
  }

  init() {
      this.button ? this.button.addEventListener('click', (event) => this.toggleMenu(event)) : null;
      document.addEventListener('click', (event) => this.handleDocumentClick(event));
  }

  toggleMenu(event) {
      event.stopPropagation();
      const isExpanded = this.button.getAttribute("aria-expanded") === "true";

      this.button.setAttribute("aria-expanded", !isExpanded);
      this.menu.classList.toggle('show');
  }

  handleDocumentClick(event) {
      if (this.dropdown && !this.dropdown.contains(event.target)) {
          this.menu.classList.remove('show');
      }
  }
}

class AnchorMenu {
  constructor(selector) {
    // this.body = document.querySelector("body");
    // this.backdrop = document.querySelector(".backdrop");
    this.menuLinks = document.querySelectorAll(selector);
    this.init();
  }

  init() {
    if (this.menuLinks.length > 0) {
      this.menuLinks.forEach(link => {
        link.addEventListener("click", (event) => this.handleClick(event, link));
      });

      if (window.location.hash) {
        const hash = window.location.hash.substring(1);
        this.scrollToSection(hash);
      }
    }
  }

  handleClick(event, link) {
    event.preventDefault();

    const targetId = link.getAttribute("href").substring(1);
    const homePaths = ["/", "/en/", "/eu/"];
    const isHome = homePaths.includes(window.location.pathname);

    if (isHome) {
      this.scrollToSection(targetId);
    } else {
      window.location.href = `/#${targetId}`;
    }
  }

  scrollToSection(id) {
    const targetElement = document.getElementById(id);

    if (targetElement) {
      const body = document.querySelector("body");
      const sideMenu = document.querySelector(".js-side-menu");
      const backdrop = document.querySelector(".backdrop");

      if (body) {
        body.classList.remove("no-scroll");
      }
      if(sideMenu) {
        sideMenu.classList.remove("open");
      }

      if(backdrop) {
        backdrop.classList.remove("active");
      }

      const offset = targetElement.offsetTop - 50;
      window.scrollTo({
        top: offset,
        behavior: "smooth"
      });
    }
  }
}

class Scroll {
  lastScrollTop = 0;

  constructor() {
    this.siteHeader = document.querySelector("#site-header");

    if (!this.siteHeader) {
      console.error("No se encontró el elemento con id 'site-header'");
      return;
    }

    this.init();
    window.addEventListener('scroll', this.handleScroll.bind(this));
  }

  init() {
    if (window.scrollY > 80) {
      this.siteHeader.classList.add('hide');
    }
  }

  handleScroll() {
    const scrollTop = window.scrollY || document.documentElement.scrollTop;
    //console.log("scrollTop:", scrollTop);

    if (scrollTop < 100) {
      this.siteHeader.classList.add('hide');
    }

    if (scrollTop > 10) {
      if (scrollTop < this.lastScrollTop) {
        this.siteHeader.classList.remove('hide');
        this.siteHeader.classList.add('show');
      } else {
        this.siteHeader.classList.add('hide');
        this.siteHeader.classList.remove('show');
      }
    } 
    else {
      this.siteHeader.classList.remove('hide');
      this.siteHeader.classList.remove('show');
    }

    this.lastScrollTop = scrollTop <= 0 ? 0 : scrollTop;
  }
}


document.addEventListener('DOMContentLoaded', () => {
  new LanguageDropdown('.site-header .language-selector');
  new LanguageDropdown('.side-menu .language-selector');
  new AnchorMenu(".menu-item.anchor a");
  new Scroll();
});

